import React, {Component} from 'react';
import "../../LinkPages/FaqPages/AboutPayment.css"
import FocusPageId from "../../FocusPageId";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";


let i = 0;

class MemberRegistration extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        // element.parentNode.scrollTop= element.offsetTop;
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });

    }

    constructor(props) {
        super(props);

        this.positionAdject = this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //  document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };

    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <li><h3 className="inline-block-element"><b>会員登録・登録情報について</b></h3></li>
                     <div className="brElement"></div> <div className="brElement"></div>
                    <h4 id="a"><b> 会員登録は無料ですか？</b>
                    </h4>
                    <p className='all-content-font-size'>登録費用は一切かかりません！安心してご登録ください。
                    </p>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="b"><b> 会員登録後、ログインができません。</b>
                    </h4>
                    <p className='all-content-font-size'>再度、ご登録いただいたメールアドレスとパスワードをご確認ください。
                    </p>
                    <p className='all-content-font-size'> ブラウザのキャッシュをクリアして、再起動するとログインできることがあります。
                    </p>
                    <p className='all-content-font-size'> それでもログインできないようでしたら、サポート＞お問合せよりご連絡お願いいたします。
                    </p>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="c"><b> パスワードを忘れてしまった場合はどうしたらいいですか？</b>
                    </h4>
                    <p className='all-content-font-size'>ログインの「パスワードを忘れた方へ」をクリックし、ご登録いただいたメールアドレスをご入力ください。当該メールアドレスにパスワード再設定のご案内メールをお送りします。メールに記載のURLよりパスワードの再設定をお願いいたします。
                    </p>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="d"><b>アカウントの削除方法について教えてください。</b>
                    </h4>
                    <p className='all-content-font-size'>ログイン後、アカウント削除より手続き可能です。
                    </p>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="e"><b> 住所やメールアドレスの変更手続きはどうすればいいですか？</b>
                    </h4>
                    <p className='all-content-font-size'>ログイン後、アカウント内の“住所を変更”から手続き可能です。
                    </p>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="f"><b>パスワードを変更したい場合。</b>
                    </h4>
                    <p className='all-content-font-size'>ログイン後、アカウント内の“パスワードの変更”から手続き可能です。
                    </p>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <h4 id="g"><b>フリーメールで、会員登録できますか？</b>
                    </h4>
                    <p className='all-content-font-size'>登録可能です。Googleアカウントでの会員登録もできます。
                    </p>
                    <p className='all-content-font-size'> なお、当サイトからの連絡メールなどが迷惑メールへ振り分けられることがありますのでご注意をお願いします。
                    </p>
                    <p className='all-content-font-size'> なお、法人としてご利用の場合は会社用のメールアドレスにてご利用ください。
                    </p>
                     <div className="brElement"></div>
                     <div className="brElement"></div>
                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/memberregistrationTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>

                </div>
            </div>

        );
    }
}

export default MemberRegistration;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/MemberRegistration.js